import React from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import TopTabPanel from '../../../components/tabPanel/tabPanel';
import BillPhone from './components/Phone/phone';
import Static from './components/static/static';
import BillId from './components/billId/billId';
import Subscription from './components/subscription/subscription';
import Custom from "./components/custom/custom"
import * as img from "../../../assets/images"

const types: any = {
    1: {
        text: "تلفن همراه",
        icon: img.Mobile,
        Component: BillPhone
    },
    2: {
        text: "تلفن ثابت",
        icon: img.Phone,
        Component: Static
    },
    3: {
        text: "قبض برق",
        icon: img.Electricity,
        Component: BillId
    },
    4: {
        text: "قبض گاز",
        icon: img.Gas,
        Component: Subscription
    },
    5: {
        text: "قبض اب",
        icon: img.Water,
        Component: BillId
    },
    6: {
        text: "پرداخت با شناسه",
        icon: undefined,
        Component: Custom
    },
}

const BillInfo = () => {
    // --------- states

    //---------- end states

    // --------- variables
    const classes = useStyles();
    const { info: { billType } } = useSelector(({ payment }: any) => payment)
    const { Component, text, icon } = types?.[billType] || {}
    // --------- end variables

    // --------- useEffects

    // --------- end useEffects

    // --------- functions

    // --------- end functions

    return (
        <div style={{ marginTop: '20px' }}>
            <TopTabPanel />
            <Grid container justifyContent="center">
                <Grid
                    item
                    className={classes.responsiveBreak}
                    xs={12}
                    md={6}
                    lg={5}
                >
                    {/* @ts-ignore */}
                    <Box className="dir box mainBox p-res m-bill">
                        {/* @ts-ignore */}
                        {
                            typeof Component !== 'string' &&
                            <Component text={text} icon={icon} />
                        }
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default BillInfo;


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        responsiveBreak: {
            [theme.breakpoints.only("md")]: {},
        },

    })
);

